import { ComponentProps } from "react";

const ChevronDownIcon = (props: ComponentProps<"svg">) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
      <rect width="24" height="24" fill="none" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.43427 9.43433C7.74669 9.12191 8.25322 9.12191 8.56564 9.43433L12 12.8686L15.4343 9.43433C15.7467 9.12191 16.2532 9.12191 16.5656 9.43433C16.8781 9.74675 16.8781 10.2533 16.5656 10.5657L12.5656 14.5657C12.4156 14.7157 12.2121 14.8 12 14.8C11.7878 14.8 11.5843 14.7157 11.4343 14.5657L7.43427 10.5657C7.12185 10.2533 7.12185 9.74675 7.43427 9.43433Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronDownIcon;
